import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {WmsDialogBodyComponent} from "@wms/components";
import {DialogService, I18nService} from "@wms/services";
import {WM_ACADEMY_LINK} from "@wms/core";

@Component({
  selector: 'wms-edit-in-wm-info',
  standalone: true,
  imports: [CommonModule, WmsDialogBodyComponent],
  templateUrl: './edit-in-wm-info.component.html',
  styleUrls: ['./edit-in-wm-info.component.less']
})
export class EditInWmInfoComponent {
  locale: any
  wmAcademyLink: string;
  constructor(private dialogService: DialogService, private i18nService: I18nService) {
    this.locale = this.i18nService.getMessages();
    this.wmAcademyLink = WM_ACADEMY_LINK;
  }

  closeDialog() {
    this.dialogService.close('EditInWMInfoScreen');
  }
}
